const linkElement = document.querySelector('.threw-d-view-link');

if (linkElement) {
    linkElement.addEventListener('click', function (event) {
        event.preventDefault(); // Prevent default anchor behavior

        // Get the target element
        const target = document.querySelector('#three-d-view');

        if (target) {
            // Scroll to the target element and adjust for the sticky header
            const headerHeight = 165; // Height of the sticky header in pixels
            const targetPosition = target.getBoundingClientRect().top + window.pageYOffset - headerHeight;

            window.scrollTo({
                top: targetPosition,
                behavior: 'smooth' // Smooth scrolling
            });
        } else {
            console.warn('Target element #three-d-view not found.');
        }
    });
} else {
    console.warn('.threw-d-view-link element not found.');
}
